export default "__VITE_ASSET__jLsScvV8__"